import { IAttachmentDto } from "./IAttachmentDto";

export abstract class AttachmentFactory {
    abstract createAttachment(): IAttachmentDto;
}
